<template>
  <div class="approver-main">
    <template v-if="addFormData || viewFormData">
      <fm-generate-form
        v-if="formDataTemplate"
        ref="generateFormRef"
        :data="formDataTemplate"
        :edit="!viewFormData"
      ></fm-generate-form>
    </template>
    <template v-if="!addFormData && !viewFormData">
      <slot name="header">
        <header class="main-header">
          <div class="step-tab">
            <template v-for="(item, i) in steps">
              <div
                :key="i"
                class="step"
                :class="{ active: activeStep === item.key }"
                @click="changeSteps(item.key)"
              >
                {{ item.label }}
              </div>
            </template>
            <div
              class="ghost-step step"
              :style="{ transform: translateX }"
            ></div>
          </div>
        </header>
      </slot>
      <section class="main-body">
        <BasicSetting
          v-show="activeStep === 'basicSetting'"
          ref="basicSetting"
          :conf="formData.basicSetting"
          :workConfig="workConfig"
          tabName="basicSetting"
          @initiatorChange="onInitiatorChange"
          @changeFormType="changeFormType"
          @changeProjectType="changeProjectType"
        />

        <DynamicForm
          v-show="activeStep === 'formDesign'"
          ref="formDesign"
          :conf="formData.formData"
          :styleId="styleId"
          :isApprover="isApprover"
          :isFlagDelete="isFlagDelete"
          :workConfig="workConfig"
          tabName="formDesign"
        />

        <Process
          v-show="activeStep === 'processDesign'"
          ref="processDesign"
          :conf="formData.processData"
          :workConfig="workConfig"
          tabName="processDesign"
          @startNodeChange="onStartChange"
        />

        <!-- <AdvancedSetting
        v-show="activeStep === 'advancedSetting'"
        ref="advancedSetting"
        :conf="mockData.advancedSetting"
      /> -->
      </section>
      <slot name="footer">
        <footer class="main-footer">
          <el-button class="publish-btn" @click="goBack()">
            取消
          </el-button>
          <el-button
            v-if="isPreview"
            type="primary"
            plain
            class="publish-btn"
            @click="previewView()"
          >
            预览
          </el-button>
          <el-button
            v-if="isDraft && (subFormData.status === 0 || isCopy || !formId)"
            type="primary"
            plain
            class="publish-btn"
            :loading="saveBtnLoading"
            @click="saveForm()"
          >
            保存
          </el-button>
          <el-button
            type="primary"
            class="publish-btn"
            :loading="publishBtnLoading"
            @click="publish()"
          >
            发布
          </el-button>
        </footer>
      </slot>
      <!-- 预览组件 start -->
      <PreviewModal
        :show.sync="previewModalVisible"
        :workConfig="workConfig"
        :previewData="formData"
        :hasBasic="hasBasic"
        :hasForm="hasForm"
        :hasProcess="hasProcess"
      />
      <!-- 预览组件 end -->
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import Process from "@/components/Process";
import DynamicForm from "@/components/DynamicForm";
import BasicSetting from "@/components/BasicSetting";
// import AdvancedSetting from "@/components/AdvancedSetting";
import PreviewModal from "./previewModal"; // 预览组件
import MockData from "./mockData.js";
import { initProcessData } from "@/utils";
const beforeUnload = function(e) {
  var confirmationMessage = "离开网站可能会丢失您编辑得内容";
  (e || window.event).returnValue = confirmationMessage; // Gecko and Trident
  return confirmationMessage; // Gecko and WebKit
};
window.workFlowConfig = {};

export default {
  name: "Home",
  components: {
    Process,
    DynamicForm,
    BasicSetting,
    PreviewModal
  },
  // beforeRouteEnter(to, from, next) {
  //   window.addEventListener("beforeunload", beforeUnload);
  //   next();
  // },
  // beforeRouteLeave(to, from, next) {
  //   window.removeEventListener("beforeunload", beforeUnload);
  //   next();
  // },
  props: {
    // 配置环境参数
    urlSuffix: {
      type: String,
      default: "-dev"
    },
    // 新建表单数据
    addFormData: {
      type: Boolean,
      default: false
    },
    // 预览表单数据
    viewFormData: {
      type: Boolean,
      default: false
    },
    // 自定义表单数据
    formDataJson: {
      type: [Object, String],
      default: ""
    },
    // 是否是超管
    isAdminFlag: {
      type: Boolean,
      default: false
    },
    // 是否是复制模板
    isCopy: {
      type: Boolean,
      default: false
    },
    // 是否是企业管理员
    isCompanyFlag: {
      type: Boolean,
      default: false
    },
    // 是否显示保存按钮
    isDraft: {
      type: Boolean,
      default: true
    },
    // 是否显示预览按钮
    isPreview: {
      type: Boolean,
      default: true
    },
    // 是否是审批表单，初始化的时候回带上默认审批功能
    isApprover: {
      type: Boolean,
      default: false
    },
    // 审批结果是否允许删除
    isFlagDelete: {
      type: Boolean,
      default: true
    },
    // 显示属性设置
    hasBasic: {
      type: Boolean,
      default: true
    },
    // 显示内容设置
    hasForm: {
      type: Boolean,
      default: true
    },
    // 显示流程设置
    hasProcess: {
      type: Boolean,
      default: true
    },
    // 表单标识(1:自定义表单,2:固定表单)
    flag: {
      type: Number,
      default: 1
    },
    // 项目id
    projectId: {
      type: String,
      default: ""
    },
    // 项目类型
    /*
      construction3.0 施工
      decoration 精装修
    */
    projectType: {
      type: String,
      default: "construction3.0"
    },
    // 项目类型列表
    projectTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 表单id
    formId: {
      type: String,
      default: ""
    },
    // 审批样式id
    styleId: {
      type: String,
      default: ""
    },
    // 登录状态
    token: {
      type: String,
      default: ""
    },
    // 公司列表
    companyList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 人员type
    userType: {
      type: Number,
      default: 6
    },
    // API配置
    configApi: {
      type: [Object, String],
      default: ""
    },
    // 表单类型 1 需审批表单 2 无审批表单
    formType: {
      type: Number,
      default: 1
    },
    // 表单属性设置
    basicSetting: {
      type: [Object, String],
      default: ""
    },
    // 表单名称最多可输入字数
    formNameMax: {
      type: Number,
      default: 15
    },
    // 是否是单公司模式
    isSingleCompany: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mockData: MockData, // 可选择诸如 $route.param，Ajax获取数据等方式自行注入
      formData: {
        basicSetting: {
          formType: this.hasProcess && this.formType === 1 ? 1 : 2,
          flag: this.flag,
          projectType: this.projectType,
          allowInitiatorIds: "all"
        },
        formData: {},
        template: "",
        processData: {}
      },
      subFormData: {}, // 提交表单数据
      activeStep: "", // 激活的步骤面板
      steps: [],
      previewModalVisible: false, // 预览窗口
      workConfig: {
        isAdminFlag: this.isAdminFlag,
        isCopy: this.isCopy,
        isDraft: this.isDraft,
        isCompanyFlag: this.isCompanyFlag,
        token: this.token,
        projectId: this.projectId,
        projectType: this.projectType,
        formId: this.formId,
        configApi: {},
        projectTypeList: this.projectTypeList,
        userType: this.userType,
        userList: [],
        userListNoTel: [],
        companyList: this.companyList,
        departList: [], // 所有部门数据
        formItemList: [],
        groupList: [], // 所属小组
        formNameMax: this.formNameMax,
        isSingleCompany: this.isSingleCompany
      }, // 工作流参数
      formParams: {
        token: this.token,
        projectType: this.projectType,
        projectId: this.projectId
      },
      formDataTemplate: this.formDataJson, // 表单预览数据
      saveBtnLoading: false,
      publishBtnLoading: false
    };
  },
  computed: {
    translateX() {
      return `translateX(${this.steps.findIndex(
        t => t.key === this.activeStep
      ) * 100}%)`;
    }
  },
  watch: {
    "formData.basicSetting.formType"() {
      this.getSteps();
    },
    activeStep(val) {
      this.getFormDesign();
    },
    companyList() {
      this.initConfigApi();
    },
    configApi() {
      this.initConfigApi();
    },
    formDataJson(val) {
      if (!val) {
        return;
      }
      this.formDataTemplate = Object.assign({}, val);
    }
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      if (this.basicSetting) {
        this.formData.basicSetting = Object.assign(
          {},
          this.formData.basicSetting,
          this.basicSetting
        );
      }
      this.getConfigApi();
    },
    // 设置默认API地址
    getConfigApi() {
      let configApi = {
        companyApi:
          this.configApi.companyApi ||
          `/cim6d-system${this.urlSuffix}/cim6d/system/project/organ/query`, // 公司API
        fileUploadApi:
          this.configApi.fileUploadApi ||
          `/cim6d-file${this.urlSuffix}/noToken/file/commonFile/visitor/upload/drag-form`, // 文件上传API
        fileByIdApi:
          this.configApi.fileByIdApi ||
          `/cim6d-file${this.urlSuffix}/file/manage/get/`, // 文件Id查询API
        filePreviewApi:
          this.configApi.filePreviewApi ||
          `/cim6d-file${this.urlSuffix}/noToken/file/commonFile/onlinePreview/`, // 文件在线预览Api
        queryGroup:
          this.configApi.queryGroup ||
          `/cim6d-process${this.urlSuffix}/oa/form/group/select`, // 表单分组下拉列表
        getFormDetails:
          this.configApi.getFormDetails ||
          `/cim6d-process${this.urlSuffix}/oa/form/get/`, // 获取表单详情
        saveForm:
          this.configApi.saveForm ||
          `/cim6d-process${this.urlSuffix}/oa/form/save`, // 保存表单
        saveAndPublish:
          this.configApi.saveAndPublish ||
          `/cim6d-process${this.urlSuffix}/oa/form/saveAndPublish`, // 保存表单并发布
        saveAuditStyle:
          this.configApi.saveAuditStyle ||
          `/cim6d-process${this.urlSuffix}/oa/audit/style/save`, // 保存审批样式
        getAuditStyle:
          this.configApi.getAuditStyle ||
          `/cim6d-process${this.urlSuffix}/oa/audit/style/select`, // 审批样式下拉列表
        getDetailsAuditStyle:
          this.configApi.getDetailsAuditStyle ||
          `/cim6d-process${this.urlSuffix}/oa/audit/style/get/`, // 审批样式详情
        deleteAuditStyle:
          this.configApi.deleteAuditStyle ||
          `/cim6d-process${this.urlSuffix}/oa/audit/style/delete/` // 删除审批样式
      };
      this.workConfig.configApi = configApi;
      this.initConfigApi();
      this.setToken();
    },
    // 初始化步骤
    getSteps() {
      let list = [];
      if (this.hasBasic) {
        list.push({
          label: "属性设置",
          key: "basicSetting"
        });
      }
      if (this.hasForm) {
        list.push({
          label: "内容设置",
          key: "formDesign"
        });
      }
      if (this.hasProcess && this.formData.basicSetting.formType === 1) {
        list.push({
          label: "流程设置",
          key: "processDesign"
        });
      }
      // console.log("初始化步骤", this.formData);
      this.activeStep = list[0].key;
      this.steps = list;
    },
    // 设置token
    setToken() {
      if (!this.token) {
        this.getSteps();
        return;
      }
      this.getFormDetails();
    },
    // 初始化API数据
    initConfigApi() {
      let userList = [];
      let userListNoTel = [];
      let departList = [];
      const formatArray = array => {
        array.map(item => {
          let companyNameObj = _.find(this.companyList, {
            targetId: item.companyId
          });
          let companyName = companyNameObj ? companyNameObj.name : "";
          if (item.organType === this.userType) {
            userList.push({
              label: `${item.name} ${item.mobile ? item.mobile : ""}`,
              value: item.targetId,
              targetId: item.targetId,
              companyId: item.companyId,
              companyName: companyName
            });
            userListNoTel.push({
              label: item.name,
              tel: item.mobile,
              value: item.targetId,
              targetId: item.targetId,
              companyId: item.companyId,
              companyName: companyName
            });
          } else {
            departList.push({
              label: `${item.name} ${item.mobile ? item.mobile : ""}`,
              value: item.targetId,
              key: item.targetId,
              targetId: item.targetId,
              companyId: item.companyId,
              companyName: companyName
            });
          }
          if (item.children) {
            formatArray(item.children);
          }
        });
      };
      this.workConfig.companyList = this.companyList;
      formatArray(this.companyList);
      this.workConfig.userList = userList;
      this.workConfig.userListNoTel = userListNoTel;
      this.workConfig.departList = departList;
      workFlowConfig = this.workConfig;
    },
    // 表单分组下拉列表
    async queryGroup(e) {
      if (
        !this.workConfig.configApi.queryGroup ||
        this.addFormData ||
        this.viewFormData
      ) {
        return;
      }
      let projectType = e || this.projectType;
      let params = Object.assign({}, this.formParams, {
        flag: this.flag,
        projectType
      });
      let result = await this.$axios.post(
        this.workConfig.configApi.queryGroup,
        params
      );
      let datas = result.data;
      let list = [];
      datas.map(item => {
        list.push({
          label: item.name,
          value: item.id
        });
      });
      this.workConfig.groupList = list;
    },
    // 改变项目类型
    changeProjectType(projectType) {
      if (!projectType) {
        return;
      }
      this.queryGroup(projectType);
    },
    // 初始化选择的用户
    initSelectIds(str) {
      let userIds = str.split(",");
      let userList = [];
      let list = _.cloneDeep(this.companyList);
      let selectIds = [];
      const formatArray = array => {
        array.map(e => {
          if (e.type === this.workConfig.userType) {
            userList.push({
              label: e.label,
              value: e.value,
              key: e.value
            });
          }
          if (e.children) {
            formatArray(e.children);
          }
        });
      };
      formatArray(list);
      userList.map(item => {
        if (userIds.includes(item.value)) {
          selectIds.push(item);
        }
      });
      // console.log("----000---", userIds, userList, selectIds);
      return _.map(selectIds, "label").join(",");
    },
    // 获取表单详情 - 异步
    async getFormDetails() {
      if (!this.formId) {
        this.queryGroup();
        this.getSteps();
        return;
      }
      let result = await this.$axios.get(
        `${this.workConfig.configApi.getFormDetails}${this.formId}`,
        this.formParams
      );
      let datas = result.data;
      this.queryGroup(datas.projectType);
      if (this.isCopy) {
        datas.allowInitiatorIds = "all";
        datas.allowInitiatorNames = "所有人";
        if (!datas.projectId && !this.isCompanyFlag) {
          datas.groupId = "";
        }
      }
      this.formData.basicSetting = Object.assign({}, datas);
      this.formData.formData = Object.assign({}, JSON.parse(datas.template));
      this.formDataTemplate = datas.template
        ? Object.assign({}, JSON.parse(datas.template))
        : "";
      let childNode = {};
      let list = [];
      let processConfigList = datas.processConfigList || [];
      processConfigList.map((item, i) => {
        if (this.isCopy) {
          item.userIds = "";
          item.roleIds = "";
          item.nodeContent =
            item.nodeType === 1 ? "请设置审批人" : "请设置抄送人";
        }

        let approvers = [];
        let tempList =
          item.type === 1
            ? item.userIds.split(",").filter(e => e)
            : item.roleIds.split(",").filter(e => e);
        tempList.map(e => {
          let eItem =
            item.type === 1
              ? _.find(this.workConfig.userListNoTel, { value: e })
              : _.find(this.workConfig.departList, { value: e });
          approvers.push(eItem);
        });
        // console.log("tempList2222222", item, tempList);
        list.push({
          type: item.nodeType === 1 ? "approver" : "copy",
          content: item.nodeContent,
          nodeId: item.id,
          prevId: !i ? item.formId : processConfigList[i - 1].id,
          properties: {
            title: item.nodeName,
            initiator: approvers,
            menbers: approvers,
            approvers,
            assigneeType: item.type === 1 ? "user" : "role",
            flag: item.flag === 2 ? "2" : "1",
            auditMode: item.auditMode,
            downAddFlag:
              item.downAddFlag === 1 || item.downAddFlag === "1" ? 1 : 0,
            auditStyleId: item.auditStyleId,
            auditStyleName: item.auditStyleName,
            auditStyleType: item.auditStyleType,
            optionalMultiUser: true,
            optionalRange: "ALL",
            formStyle: {
              fileIds: "",
              fileIdsChecked: item.requireAttachment === 1,
              flag: 1,
              remark: "",
              remarkChecked: item.requireAuditOpinion === 1,
              selectStyle: "",
              status: 0
            }
          },
          childNode: null
        });
      });
      list.map((e, i) => {
        e.childNode = list[i + 1];
        if (!i) {
          childNode = e;
        }
      });
      let processData = {
        type: "start",
        content:
          datas.allowInitiatorIds === "all" || this.isCopy
            ? "所有人"
            : datas.allowInitiatorNames,
        nodeId: datas.id,
        prevId: null,
        properties: {
          title: "发起人",
          initiator:
            datas.allowInitiatorIds === "all" || this.isCopy ? "ALL" : []
        },
        childNode
      };
      if (!datas.processConfigList || datas.processConfigList.length === 0) {
        processData = "";
      }
      this.formData.processData = processData;
      this.subFormData = Object.assign({}, datas);
      let formDataTemp = datas.formData ? JSON.parse(datas.formData) : "";
      this.formDataTemplate.list &&
        this.formDataTemplate.list.map(e => {
          if (e.type === "table") {
            let defaultValue = e.options.defaultValue;
            let params = {};
            params[e.model] = defaultValue;

            this.$nextTick(() => {
              this.$refs.generateFormRef.setData(params);
            });
          }
        });
      // console.log(
      //   "获取表单详情",
      //   datas,
      //   formDataTemp,
      //   this.formDataTemplate,
      //   processData
      // );
      this.getSteps();
      this.initConfigApi();
    },
    // 获取表单数据
    async getFormDesign() {
      if (!this.$refs.formDesign) {
        return;
      }
      let result = await this.$refs.formDesign.getData();
      this.workConfig.formItemList = result.formData.list;
      this.initConfigApi();
    },
    // 改变选项卡
    changeSteps(key) {
      this.activeStep = key;
    },
    // 预览
    previewView() {
      this.buildData((formData, subFormData) => {
        // console.log(1111, formData);
        this.previewModalVisible = true;
        this.formData = formData;
        return;
        // this.subFormData = subFormData;
      });
    },
    // 保存表单
    saveForm() {
      this.buildData((formData, subFormData) => {
        this.formData = formData;
        this.subFormData = subFormData;
        this.saveFormSuccess();
      });
    },
    // 保存表单 - 异步
    async saveFormSuccess() {
      this.saveBtnLoading = true;
      let params = Object.assign({}, this.subFormData, this.formParams);
      if (this.isCopy) {
        params.id = "";
      }
      try {
        await this.$axios.post(this.workConfig.configApi.saveForm, params);
        this.saveEmit();
        this.saveBtnLoading = false;
      } catch (e) {
        this.saveBtnLoading = false;
      }
    },
    // 保存成功
    saveEmit() {
      this.$message({
        type: "success",
        message: "保存成功!"
      });
      this.$emit("change");
    },
    // 发布
    publish() {
      this.buildData((formData, subFormData) => {
        this.formData = formData;
        this.subFormData = subFormData;
        this.saveAndPublish();
      }, true);
    },
    // 保存表单并发布 - 异步
    async saveAndPublish() {
      this.publishBtnLoading = true;
      let params = Object.assign({}, this.subFormData, this.formParams);
      console.log("保存成功", params);
      if (this.isCopy) {
        params.id = "";
      }
      try {
        await this.$axios.post(
          this.workConfig.configApi.saveAndPublish,
          params
        );
        this.saveEmit();
        this.publishBtnLoading = false;
      } catch (e) {
        this.publishBtnLoading = false;
      }
    },
    // 父级获取表单数据
    getFormData(callBack = () => {}) {
      this.buildData(callBack);
    },
    // 编译数据
    buildData(callBack = () => {}, isPublish = false) {
      const getCmpData = (name, isVerify) => this.$refs[name].getData(isVerify);
      const newAsync = new Promise((resolve, reject) => {
        resolve({ formData: {} });
      });
      let basicSettingRes = getCmpData("basicSetting", this.hasBasic);
      let formDesignRes = getCmpData(
        "formDesign",
        this.flag === 1 && this.hasForm && isPublish
      );
      let processDesignRes = newAsync;
      // console.log(
      //   "aaaa",
      //   this.formData.basicSetting.formType,
      //   this.isCompanyFlag,
      //   this.isAdminFlag,
      //   this.flag
      // );
      if (this.formData.basicSetting.formType === 1) {
        let processFlag = isPublish;
        if (this.isAdminFlag) {
          processFlag = false;
        }
        // console.log("3333--processFlag", this.isAdminFlag, processFlag);
        processDesignRes = getCmpData("processDesign", processFlag);
      }
      Promise.all([basicSettingRes, formDesignRes, processDesignRes])
        .then(res => {
          let basicSetting = res[0].formData;
          let formData = res[1].formData;
          let processData = res[2].formData;
          let template =
            formData.list.length > 0 ? JSON.stringify(formData) : "";
          const param = {
            basicSetting,
            processData,
            formData,
            template
          };
          let formDataObj = Object.assign({}, param);
          let subFormDataObj = Object.assign({}, basicSetting, {
            allowInitiatorNames: this.formData.basicSetting.allowInitiatorNames,
            template,
            processConfigList: initProcessData(processData, false)
          });
          // console.log(
          //   5555555,
          //   this.formData.basicSetting,
          //   formDataObj,
          //   subFormDataObj
          // );
          this.formParams.projectType = subFormDataObj.projectType;
          callBack(formDataObj, subFormDataObj);
        })
        .catch(err => {
          err.target && (this.activeStep = err.target);
          err.msg && this.$message.warning(err.msg);
        });
    },
    sendToServer(param) {
      this.$notify({
        title: "数据已整合完成",
        message: "请在控制台中查看数据输出",
        position: "bottom-right"
      });
      // console.log("配置数据", param, this.formData);
    },
    exit() {
      this.$confirm("离开此页面您得修改将会丢失, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "模拟返回!"
          });
        })
        .catch(() => {});
    },
    // 表单类型改变
    changeFormType(val) {
      this.formData.basicSetting.formType = val;
    },
    /**
     * 同步基础设置发起人和流程节点发起人
     */
    onInitiatorChange(array) {
      // console.log(1221, array); //{ array, formData }
      let companyIds = [];
      let contentList = [];
      let labels = [];
      let labelStr = "所有人";
      array.map(item => {
        let index = companyIds.indexOf(item.companyId);
        if (index < 0) {
          companyIds.push(item.companyId);
          contentList.push({
            title: item.companyName,
            list: [item.label]
          });
        } else {
          contentList[index].list.push(item.label);
        }
      });
      contentList.map(e => {
        labels.push(`<b>${e.title}:</b><br>${e.list.join(",")}`);
      });
      if (array.length > 0) {
        labelStr = labels.join("<br><br>");
      }
      if (this.isSingleCompany) {
        labelStr = _.map(contentList, "list").join("");
      }

      // console.log(
      //   "同步基础设置发起人和流程节点发起人--",
      //   array,
      //   contentList,
      //   labelStr,
      //   this.formData.processData
      // );
      const processCmp = this.$refs.processDesign;
      const startNode = processCmp.data;
      startNode.properties.initiator = array;
      startNode.content = labelStr;
      let allowInitiatorIds = _.map(array, "targetId").join(",");
      this.formData.basicSetting.allowInitiatorIds = allowInitiatorIds;
      this.formData.basicSetting.allowInitiatorNames = labelStr;
      // this.formData.basicSetting = Object.assign({}, formData, {
      //   allowInitiatorIds,
      //   allowInitiatorNames: labelStr
      // });
      processCmp.forceUpdate();
    },
    /**
     * 监听 流程节点发起人改变 并同步到基础设置 发起人数据
     */
    onStartChange(node) {
      const basicSetting = this.$refs.basicSetting;
      basicSetting.formData.initiator = node.properties.initiator;
    },
    // 取消
    goBack() {
      this.$emit("close");
    },
    // 获取设计器配置的JSON数据
    async getJSON() {
      return await this.$refs.generateFormRef.getData();
    }
  }
};
</script>
<style lang="less">
@import url("./index.less");
</style>
<style lang="less" scoped>
.publish-btn {
  margin-left: 0 !important;
  margin-right: 20px;
  padding: 10px 40px;
}
</style>
